import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const Container = styled.div`
  background-color: #FFFFFF;
  width: 100%;
  margin-bottom: 10px;
  box-shadow: 0px 2px 10px -6px #252525;
  text-decoration: none;
  border-radius: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
`

export const Info = styled.div`
  display: flex;
  flex-direction: column;
`

export const RatingContainer = styled.div`
  display: flex;
  width: auto;
  height: 30px;
  padding: 0px 12px 0px 10px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border: 1px solid #EEEEEE;
  border-radius: 15px;
  background-color: #FFFFFF;

  h3 {
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
    text-align: center;
    margin: 0px;
  }
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
`

export const Image = styled.img`
  width: 54px;
  height: 54px;
  border: 1px solid #F0F0F0;
  border-radius: 15px;
  align-self: flex-start;
`

export const InfoText = styled.p`
  font-size: 14px;
  color: #000000;
  margin: 0px;
`

export const SubTitle = styled.h3`
  font-size: 14px;
  font-weight: bold;
  line-height: 10px;
  align-self: center;
  margin: 0px;
`

export const LinkContainer = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
`

export const LinkButton = styled(Link)`
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  text-decoration: none;
  color: #000000;

  &:hover {
    background-color: #F7F7F7;
    color: #35A7FF;
  }
`
